module.exports = __webpack_public_path__ + "static/media/star-empty.d4dcdcb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/star-empty.svg
// module id = 1064
// module chunks = 0